export enum ApiQueryKeys {
  USER_SETTINGS = 'user_settings',
  SKILLS = 'skills',
  CAPABILITIES = 'capabilities',
  USER_CAPABILITIES = 'user_capabilities',
  USER_SKILLS_AVG = 'user_skills_avg',
  USER_SKILLS_STATS = 'user_skills_stats',
  DIGITAL_PROFILE = 'digital_profile',
  USERS_ME = 'users_me',
  GROWTH_EXPERIENCES = 'growth_experiences',
  CAPABILITIES_GROWTH_EXPERIENCES = 'capabilities_growth_experiences',
  USER_BY_ID = 'user_by_id',
  WORKFRONT_ME = 'workfront_me',
  WORKFRONT_WORKDAY = 'workfront_workday',
  TOP_EXPERIENCES_BY_CAPABILITY = 'top_experiences_by_capability',
  USER_PUBLIC = 'user_public',
  PREFERENCES_WHITELISTED_USERS = 'preferences_whitelisted_users',
  PREFERENCES_VISIBILITY_PREFERENCE = 'preferences_visibility_preference',
  PREFERENCES_VISIBILITY_USERS = 'preferences_visibility_users',
  PREFERENCES_CHECK_VISIBILITY = 'preferences_check_visibility',
  PROJECTS_ALL = 'projects_all',
  NEW_EXPERIENCES = 'new_experiences',
  PROFILE_PROGRESS = 'profile_progress',
  BUILDER_PROGRESS = 'builder_progress',
  MEMBER_ROLES = 'member_roles',
  FILTERS = 'resources_filters',
  RESOURCES = 'resources',
  EXPERIENCE_PATHS_SELECT = 'experience_paths_select',
  EXPERIENCE_PATHS = 'experience_paths',
  EXPERIENCE_PATHS_COMPARE = 'experience_paths_compare',
  EXPERIENCE_PATHS_SKILLS_SELECT = 'experience_paths_skills_select',
  TMP_RESOURCES = 'tmp_resources',
  EXPERIENCE_PATH_SKILLS = 'experience_path_skills',
  EXPERIENCE_SKILLS_SELECT = 'experience_skills_select',
  SKILLS_BY_ID = 'skills_by_id',
}
